<template>
    <div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in cities" :label="city.id" :key="city.id">{{city.account}}</el-checkbox>
        </el-checkbox-group>
    </div>
</template>
<script>
    import {getDeviceManagementList} from "../../api/deviceManagement";
    import {putMediaDelivery, getMediaDeliveryDetail} from "../../api/advertisingManagement";

    export default {
        props: {
            checkData: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                checkAll: false,
                checkedCities: [],
                cities: [],
                isIndeterminate: true
            };
        },
        created() {
            getDeviceManagementList({
                page: 1,
                size: 99999
            }).then((res) => {
                this.cities = res.data.listData;
            });
            if (this.checkData.length == 1) {
                getMediaDeliveryDetail({
                    id: this.checkData[0]
                }).then((res) => {
                    let resData = res.data.equipments;
                    resData.map((item)=>{
                        if(item.status){
                            this.checkedCities.push(item.id)
                        }
                    })
                })
            }
        },
        methods: {
            handleCheckAllChange(val) {
                if (val) {
                    this.cities.map(item => {
                        this.checkedCities.push(item.id)
                    })
                } else {
                    this.checkedCities = []
                }
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
            },
            submitForm() {
                let equipments = new Array()
                this.checkedCities.map(item => {
                    equipments.push({
                        id: item,
                        status: true
                    })
                });
                putMediaDelivery({
                    advertisementIds: this.checkData,
                    equipments: equipments
                }).then(() => {
                    this.$message.success("操作成功")
                    this.$emit("handleCancel");
                })
            }
        }
    };
</script>